<template>
<div class="experience-section-wrapper">
    <section class="section experience">
        <div class="container">
            <header class="section-header">
                <h2 class="title is-2">{{section_data.title}}</h2>
                <span><i></i><i></i><i></i></span>
            </header>
            <div class="experience__timeline">
                <div ref="timeline" class="timeline">
                    <div class="timeline__wrap">
                        <div class="timeline__items">
                            <div :class="['timeline__item', item.type.toLowerCase()]" v-for="item in section_data.experiences">
                                <span class="timeline__item-type icon"><i :class="'fas fa-' + (item.type == 'Education' ? 'graduation-cap' : 'code')"></i></span>
                                <div class="timeline__content">
                                    <h3 class="title is-4">{{item.title}}</h3>
                                    <p class="subtitle is-7"><strong>{{item.duration}}</strong>, {{item.subtitle}}, {{item.location}}</p>
                                    <div class="content" v-html="item.description" v-if="item.description"></div>
                                </div>
                                <span class="timeline__anchor">{{item.start}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <div class="hero" v-if="bg && section_data.stats">
        <div :class="['hero-body']" :style="'background-image: url(' + bg + ');'">
            <div class="container has-text-centered">
                <div class="columns">
                    <Stats :key="i" v-for="item, i in section_data.stats" :item="item" />
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Stats from '../elements/Stats';
import PosHandler from '../../mixins/PosHandler';
export default {
    name        :   'ExperienceSection',
    props       :   ['section_data', 'is_mobile'],
    components  :   { Stats },
    mixins      :   [ PosHandler ],
    mounted()
    {
        this.$nextTick().then(() => {
            $(this.$refs.timeline).timeline({
                verticalStartPosition: 'right',
                verticalTrigger: '150px'
            });
        });
    },
    computed    :   {
        bg()
        {
            if (this.section_data && this.section_data.hero) {
                return this.section_data.hero.url;
            }

            return null;
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/sections/ExperienceSection.vue